import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { SubProgramPreferences } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/components/subProgramPreferences';
import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { TreeProgramTopHeader } from 'components/common';

export const SubProgramPreferencesPage = () => {
    useFullStoryPageView({ pageName: executionConfig.subProgramPreferences.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader versionSelectorEnabled={false} isDisabled={true} />
                <BottomHeaderSection>
                    <ProgramTopHeader
                        showBack={true}
                        pageTitle={executionConfig.subProgramPreferences.title}
                    ></ProgramTopHeader>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <SubProgramPreferences />
            </MainContent>
        </PageContainer>
    );
};
